export default "__VITE_ASSET__a64ae540__"